module.exports = __webpack_public_path__ + "img/added-service-unit-04.84eb02a7.png";